import { CurrenciesService, WalletService } from "@/services";
import { mapActions } from "vuex";
import * as types from "@/store/types";

const transitionPage = () => import("@/components/transitionPage/index");
export default {
  name: "operation-fiat",
  components: { transitionPage },
  props: [],
  data() {
    return {};
  },
  computed: {},
  mounted() {
    this.getCurrencies();
    this.getWalletService();
    this.getExchangeService();
  },
  methods: {
    ...mapActions({
      currenciesDataAction: types.currencies.actions.SET_CURRENCIES,
      setWallets: types.operations.actions.SET_WALLET,
      setExchangeWallets: types.wallets.actions.SET_EXCHANGES_WALLETS
    }),
    getCurrencies() {
      CurrenciesService.getCurrencies().then(async response => {
        this.currenciesDataAction(response.data.data);
      });
    },
    getWalletService() {
      WalletService.getWalletV4().then(response => {
        this.setWallets(response.data.data);
      });
    },
    getExchangeService() {
      WalletService.getExchanges().then(response => {
        this.setExchangeWallets(response.data.data);
      });
    }
  }
};
